import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorMessage } from '#components/atoms/forms/index.ts';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';
import { EndpointUsersPage } from './page/EndpointUsersPage.tsx';

export function EndpointUsersRoot() {
  return (
    <Titled title={() => page('Users')}>
      <ErrorBoundary fallback={<ErrorMessage>Unable to load users. Please refresh and try again.</ErrorMessage>}>
        <Suspense fallback={<LoadingSpinner />}>
          <EndpointUsersPage />
        </Suspense>
      </ErrorBoundary>
    </Titled>
  );
}
